import { useEffect, useRef, useState } from "react";
import { useCart } from "../../context/cart-context";
import { useRestaurant } from "../../context/restaurant-context";
import { useGetPromotionLazyQuery } from "../../hooks/useGetPromotionLazyQuery";
import { CheckIfPromotionValidResponse, EOrderType } from "../../model/model";
import { Button } from "../../tabin/components/button";
import { Input } from "../../tabin/components/input";
import { ModalV2 } from "../../tabin/components/modalv2";
import { toast } from "../../tabin/components/toast";
import { convertCentsToDollars } from "../../util/util";

import "./rewardsModal.scss";
import { ELOYALTY_ACTION, IGET_LOYALTY_USER_BY_PHONE_NUMBER_EMAIL } from "../../graphql/customQueries";
import { useGetLoyaltyUsersByPhoneNumberLazyQuery } from "../../hooks/useGetLoyaltyUsersByPhoneNumberLazyQuery";
import { useGetLoyaltyUsersByEmailLazyQuery } from "../../hooks/useGetLoyaltyUsersByEmailLazyQuery";
import { useUser } from "../../context/user-context";
import { restaurantDataList } from "../page/restaurantList";

interface IRewardsModalProps {
    isOpen: boolean;
    onClose: () => void;
}

interface IUserLoyalty {
    [key: string]: {
        restaurantName: string;
        points: number;
    };
}

export const RewardsModal = (props: IRewardsModalProps) => {
    const { restaurant } = useRestaurant();
    const { user } = useUser();
    const { setUserAppliedPromotion, setUserAppliedLoyaltyId, orderType, total } = useCart();

    const { getLoyaltyUsersByPhoneNumberLazyQuery } = useGetLoyaltyUsersByPhoneNumberLazyQuery(user ? user.phoneNumber : "");
    const { getLoyaltyUsersByEmailLazyQuery } = useGetLoyaltyUsersByEmailLazyQuery(user ? user.email : "");

    // const [promotionCode, setPromotionCode] = useState("");
    const [error, setError] = useState("");
    const tempLoyaltyId = useRef<string | null>(null);

    const {
        getPromotionsByCode,
        data: getPromotionsByCodeData,
        error: getPromotionsByCodeError,
        loading: getPromotionsByCodeLoading,
    } = useGetPromotionLazyQuery();

    useEffect(() => {
        if (getPromotionsByCodeError) {
            setError("Could not apply discount code. Please try again later");
            return;
        }

        if (getPromotionsByCodeData) {
            console.log("Got getPromotionsByCodeData", getPromotionsByCodeData);

            if (getPromotionsByCodeData.length == 0) {
                setError("Invalid promo code applied");
                return;
            } else {
                const appliedPromotion = getPromotionsByCodeData[0];

                if (!orderType || !appliedPromotion.availableOrderTypes) {
                    setError("Invalid order type");
                    return;
                }

                if (!appliedPromotion.availableOrderTypes.includes(EOrderType[orderType])) {
                    setError(`This code is not valid for ${orderType.toLowerCase()}. Please try another code`);
                    return;
                }

                if (total < appliedPromotion.minSpend) {
                    setError(`Minimum spend for this promotion is $${convertCentsToDollars(appliedPromotion.minSpend)}`);
                    return;
                }

                const status = setUserAppliedPromotion(appliedPromotion); //Apply the first one if there are many with the same code.

                if (status == CheckIfPromotionValidResponse.UNAVAILABLE) {
                    setError("This code is currently unavailable. Please try again later");
                } else if (status == CheckIfPromotionValidResponse.EXPIRED) {
                    setError("This code is expired. Please try another code");
                } else if (status == CheckIfPromotionValidResponse.INVALID_PLATFORM) {
                    const platform = process.env.REACT_APP_PLATFORM;

                    if (platform) {
                        setError(`This code is not valid for ${platform.toLowerCase()}. Please try another code`);
                    } else {
                        setError(`This code is not valid for this platform. Please try another code`);
                    }
                } else {
                    setUserAppliedLoyaltyId(tempLoyaltyId.current);
                    toast.success("Your promotion has been applied!");
                    props.onClose();
                }
            }
        }
    }, [getPromotionsByCodeData, getPromotionsByCodeError]);

    const onModalClose = () => {
        props.onClose();
    };

    const onApply = async (loyaltyId: string, promoId: string, points: number) => {
        console.log("xxx...", promoId);
        console.log("xxx...", restaurant?.promotions.items);

        if (restaurant) {
            const promotionCode = restaurant.promotions.items.find((item) => item.id === promoId)?.code;
            console.log("xxx...", promotionCode);

            if (!promotionCode) {
                toast.error("Error in applying reward");
                return;
            }

            //    setPromotionCode(code);

            const userPoints = await onSearchLoyaltyHistory();

            if (!userPoints || userPoints < points) {
                toast.error("You do not have enough points to redeem this reward.");
                return;
            }

            tempLoyaltyId.current = loyaltyId;
            getPromotionsByCode({
                variables: {
                    code: promotionCode,
                    promotionRestaurantId: restaurant ? restaurant.id : "",
                },
            });
        }
    };

    const onSearchLoyaltyHistory = async () => {
        let returnPoints = 0;
        if (!user) return;

        let loyaltyUserRes: IGET_LOYALTY_USER_BY_PHONE_NUMBER_EMAIL | null = null;

        console.log("xxx...user", user);

        const resPhoneNumber = await getLoyaltyUsersByPhoneNumberLazyQuery({
            variables: {
                phoneNumber: user.phoneNumber,
            },
        });

        if (resPhoneNumber.data && resPhoneNumber.data.listLoyaltyUser.items.length > 0) {
            loyaltyUserRes = resPhoneNumber.data.listLoyaltyUser.items[0];
        }

        if (!loyaltyUserRes) {
            const resEmail = await getLoyaltyUsersByEmailLazyQuery({
                variables: {
                    email: user.email,
                },
            });

            if (resEmail.data && resEmail.data.listLoyaltyUser.items.length > 0) {
                loyaltyUserRes = resEmail.data.listLoyaltyUser.items[0];
            }
        }

        console.log("xxx...loyaltyUserRes", loyaltyUserRes);

        if (loyaltyUserRes) {
            const userLoyaltyRes: IUserLoyalty = {};

            loyaltyUserRes.loyaltyHistories.items.forEach((history) => {
                if (userLoyaltyRes[history.loyaltyRestaurant.id]) {
                    if (history.action === ELOYALTY_ACTION.EARN) {
                        userLoyaltyRes[history.loyaltyRestaurant.id] = {
                            restaurantName: history.loyaltyRestaurant.name,
                            points: userLoyaltyRes[history.loyaltyRestaurant.id].points + history.points,
                        };
                    } else if (history.action === ELOYALTY_ACTION.REDEEM) {
                        userLoyaltyRes[history.loyaltyRestaurant.id] = {
                            restaurantName: history.loyaltyRestaurant.name,
                            points: userLoyaltyRes[history.loyaltyRestaurant.id].points - history.points,
                        };
                    }
                } else {
                    if (history.action === ELOYALTY_ACTION.EARN) {
                        userLoyaltyRes[history.loyaltyRestaurant.id] = {
                            restaurantName: history.loyaltyRestaurant.name,
                            points: history.points,
                        };
                    } else if (history.action === ELOYALTY_ACTION.REDEEM) {
                        userLoyaltyRes[history.loyaltyRestaurant.id] = {
                            restaurantName: history.loyaltyRestaurant.name,
                            points: 0 - history.points,
                        };
                    }
                }
            });

            console.log("xxx...userLoyaltyRes...", userLoyaltyRes);

            let totalPoints = 0;

            restaurantDataList.forEach((restaurantData) => {
                if (userLoyaltyRes[restaurantData.id] && userLoyaltyRes[restaurantData.id].points) {
                    totalPoints += userLoyaltyRes[restaurantData.id].points;
                }
            });

            returnPoints = totalPoints;
        } else {
            returnPoints = 0;
        }

        return returnPoints;
    };

    return (
        <>
            <ModalV2 isOpen={props.isOpen} width="90%" padding="24px" disableClose={false} onRequestClose={onModalClose}>
                <div>
                    <div className="h4 mb-2">Please select your reward</div>
                    {restaurant &&
                        restaurant.loyalties &&
                        restaurant.loyalties.items.map((loyalty) => (
                            <>
                                {loyalty ? (
                                    loyalty.rewards.map((reward) => (
                                        <div key={reward.promotionId} className="reward-promotion mb-2">
                                            <div className="reward-promotion-name">
                                                {restaurant.promotions.items.find((item) => item.id === reward.promotionId)?.name}
                                            </div>
                                            <div>
                                                {reward.points} point{reward.points !== 1 ? "s" : ""}
                                            </div>
                                            <Button
                                                // disabled={loyaltyPoints < reward.points}
                                                onClick={() => onApply(loyalty.id, reward.promotionId, reward.points)}
                                            >
                                                Apply
                                            </Button>
                                        </div>
                                    ))
                                ) : (
                                    <div>No rewards available.</div>
                                )}
                            </>
                        ))}
                </div>
            </ModalV2>
        </>
    );
};
